"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tee = exports.map = exports.bind = exports.Err = exports.Ok = void 0;
const Ok = (data) => ({ ok: true, value: data });
exports.Ok = Ok;
const Err = (error) => ({ ok: false, error });
exports.Err = Err;
const bind = (f) => (r) => r.ok ? f(r.value) : r;
exports.bind = bind;
const map = (f) => (r) => r.ok ? (0, exports.Ok)(f(r.value)) : r;
exports.map = map;
const tee = (f) => (r) => {
    if (r.ok) {
        f(r.value);
    }
    return r;
};
exports.tee = tee;
//# sourceMappingURL=result.js.map